import type { PlayerFamilyRow } from '@sportninja/common/features/profile/player/playerDetails/types'
import type { FamilyMember } from '../../hooks/useFamilyMembers'

export type FamilyTableRow = PlayerFamilyRow & { member: FamilyMember }

/** Maps a family member to a DataGrid row, keeping the source for row actions. */
export const toFamilyTableRow = (member: FamilyMember): FamilyTableRow => ({
  id: member.id,
  name: member.name,
  relationship: member.relationshipLabel,
  email: member.email ?? '',
  phone: member.phone ?? '',
  status: member.isAccepted ? 'accepted' : 'invited',
  isAdmin: member.isPrimary,
  member,
})
